/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { useCallback } from 'fierry/react';

import { useBoundArg } from 'solis/navigation';

import * as Board from 'solis/react/board';

import Title from 'solis/react/element/title';
import Tile from 'solis/react/element/tile';

import descriptor from 'solis/claude/action/descriptor/create.colony';


const TILE_WIDTH = 310;
const TILE_HEIGHT = 270;


const OnSelect = (event, setDraft, id) =>
{
  setDraft(id);
};


const Component = ({ draft, selected, onClick }) =>
(
  <Tile selected = {selected} onClick = {onClick}>
    <Flex direction = 'column' gap = '3'>

      <Title>{draft.cass.name}</Title>

      <Board.WithHexes hexes = {draft.getZones().toArray()} width = {TILE_WIDTH} height = {TILE_HEIGHT} zoom = {2} settings = {Board.Preview} />

    </Flex>
  </Tile>
);


export default ({ draft }) =>
{
  const [ selected, setDraft ] = useBoundArg('draft', descriptor.inputs.draft, descriptor.scope);

  const onClick = useCallback(OnSelect, [ setDraft, draft.cass.id ]);

  return <Component draft = {draft} selected = {selected === draft.cass.id} onClick = {onClick} />;
};
